import { Reveal, Eyebrow } from "./Reveal";

export default function Partners() {
  return (
    <section
      className="bg-mm-surface py-20 sm:py-24 border-y border-mm-green/15 relative overflow-hidden"
      data-testid="partners-section"
    >
      {/* faint grid backdrop */}
      <div
        className="absolute inset-0 pointer-events-none opacity-[0.04]"
        style={{
          backgroundImage:
            "linear-gradient(to right, rgba(0,177,64,0.5) 1px, transparent 1px), linear-gradient(to bottom, rgba(0,177,64,0.5) 1px, transparent 1px)",
          backgroundSize: "80px 80px",
        }}
      />

      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 relative">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto">
          <Reveal>
            <Eyebrow>Trusted By Leading Fleet Operators</Eyebrow>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-4 font-heading font-black uppercase tracking-tight text-white text-3xl sm:text-4xl leading-tight">
              Chosen for national{" "}
              <span className="text-mm-green">fleet programs</span>.
            </h2>
          </Reveal>
        </div>

        {/* Logo strip, no box, logos filtered to monochrome white on dark theme */}
        <Reveal delay={0.15}>
          <div className="mt-14 flex flex-wrap items-center justify-center">
            <img
              src="/assets/partners.png"
              alt="Mobile Maintenance national fleet partners"
              className="h-24 sm:h-28 w-auto opacity-70 hover:opacity-100 transition-opacity duration-500"
              style={{ filter: "brightness(0) invert(1)" }}
              data-testid="partners-logos-image"
            />
          </div>
        </Reveal>

        {/* Footer caption */}
        <div className="mt-14 flex items-center justify-center gap-6 font-mono text-[10px] tracking-[0.3em] uppercase text-gray-500">
          <span className="h-px bg-mm-green/25 flex-1 max-w-[120px]" />
          <span>Long-Standing Vendor Relationships</span>
          <span className="h-px bg-mm-green/25 flex-1 max-w-[120px]" />
        </div>
      </div>
    </section>
  );
}
